import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { MONTH_ITEM_HEIGHT as v } from "../config.js";
import { getQuarterString as k, getMonthString as S, getYearString as C } from "../utils.js";
import { useCalendarProps as b, useCalendar as O } from "./use-calendar.js";
import _ from "../../../_mixins/use-locale.js";
import g from "../../../_internal/focus-detector/src/FocusDetector.js";
import d, { XButton as $ } from "../../../button/src/Button.js";
import { resolveSlotWithTypedProps as h, resolveWrappedSlot as j } from "../../../_utils/vue/resolve-slot.js";
import u from "../../../_internal/scrollbar/src/Scrollbar.js";
import w from "../../../../../../../vueuc@0.4.64_vue@3.5.18/node_modules/vueuc/es/virtual-list/src/VirtualList.js";
import { defineComponent as M, onMounted as B, h as a } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const T = M({
  name: "MonthPanel",
  props: Object.assign(Object.assign({}, b), {
    type: {
      type: String,
      required: !0
    },
    // panelHeader prop
    useAsQuickJump: Boolean
  }),
  setup(t) {
    const r = O(t, t.type), {
      dateLocaleRef: s
    } = _("DatePicker"), l = (e) => {
      switch (e.type) {
        case "year":
          return C(e.dateObject.year, e.yearFormat, s.value.locale);
        case "month":
          return S(e.dateObject.month, e.monthFormat, s.value.locale);
        case "quarter":
          return k(e.dateObject.quarter, e.quarterFormat, s.value.locale);
      }
    }, {
      useAsQuickJump: c
    } = t, i = (e, o, n) => {
      const {
        mergedIsDateDisabled: p,
        handleDateClick: m,
        handleQuickMonthClick: f
      } = r;
      return a("div", {
        "data-n-date": !0,
        key: o,
        class: [`${n}-date-panel-month-calendar__picker-col-item`, e.isCurrent && `${n}-date-panel-month-calendar__picker-col-item--current`, e.selected && `${n}-date-panel-month-calendar__picker-col-item--selected`, !c && p(e.ts, e.type === "year" ? {
          type: "year",
          year: e.dateObject.year
        } : e.type === "month" ? {
          type: "month",
          year: e.dateObject.year,
          month: e.dateObject.month
        } : e.type === "quarter" ? {
          type: "month",
          year: e.dateObject.year,
          month: e.dateObject.quarter
        } : null) && `${n}-date-panel-month-calendar__picker-col-item--disabled`],
        onClick: () => {
          c ? f(e, (y) => {
            t.onUpdateValue(y, !1);
          }) : m(e);
        }
      }, l(e));
    };
    return B(() => {
      r.justifyColumnsScrollState();
    }), Object.assign(Object.assign({}, r), {
      renderItem: i
    });
  },
  render() {
    const {
      mergedClsPrefix: t,
      mergedTheme: r,
      shortcuts: s,
      actions: l,
      renderItem: c,
      type: i,
      onRender: e
    } = this;
    return e == null || e(), a("div", {
      ref: "selfRef",
      tabindex: 0,
      class: [`${t}-date-panel`, `${t}-date-panel--month`, !this.panel && `${t}-date-panel--shadow`, this.themeClass],
      onFocus: this.handlePanelFocus,
      onKeydown: this.handlePanelKeyDown
    }, a("div", {
      class: `${t}-date-panel-month-calendar`
    }, a(u, {
      ref: "yearScrollbarRef",
      class: `${t}-date-panel-month-calendar__picker-col`,
      theme: r.peers.Scrollbar,
      themeOverrides: r.peerOverrides.Scrollbar,
      container: this.virtualListContainer,
      content: this.virtualListContent,
      horizontalRailStyle: {
        zIndex: 1
      },
      verticalRailStyle: {
        zIndex: 1
      }
    }, {
      default: () => a(w, {
        ref: "yearVlRef",
        items: this.yearArray,
        itemSize: v,
        showScrollbar: !1,
        keyField: "ts",
        onScroll: this.handleVirtualListScroll,
        paddingBottom: 4
      }, {
        default: ({
          item: o,
          index: n
        }) => c(o, n, t)
      })
    }), i === "month" || i === "quarter" ? a("div", {
      class: `${t}-date-panel-month-calendar__picker-col`
    }, a(u, {
      ref: "monthScrollbarRef",
      theme: r.peers.Scrollbar,
      themeOverrides: r.peerOverrides.Scrollbar
    }, {
      default: () => [(i === "month" ? this.monthArray : this.quarterArray).map((o, n) => c(o, n, t)), a("div", {
        class: `${t}-date-panel-${i}-calendar__padding`
      })]
    })) : null), j(this.datePickerSlots.footer, (o) => o ? a("div", {
      class: `${t}-date-panel-footer`
    }, o) : null), l != null && l.length || s ? a("div", {
      class: `${t}-date-panel-actions`
    }, a("div", {
      class: `${t}-date-panel-actions__prefix`
    }, s && Object.keys(s).map((o) => {
      const n = s[o];
      return Array.isArray(n) ? null : a($, {
        size: "tiny",
        onMouseenter: () => {
          this.handleSingleShortcutMouseenter(n);
        },
        onClick: () => {
          this.handleSingleShortcutClick(n);
        },
        onMouseleave: () => {
          this.handleShortcutMouseleave();
        }
      }, {
        default: () => o
      });
    })), a("div", {
      class: `${t}-date-panel-actions__suffix`
    }, l != null && l.includes("clear") ? h(this.datePickerSlots.clear, {
      onClear: this.handleClearClick,
      text: this.locale.clear
    }, () => [a(d, {
      theme: r.peers.Button,
      themeOverrides: r.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleClearClick
    }, {
      default: () => this.locale.clear
    })]) : null, l != null && l.includes("now") ? h(this.datePickerSlots.now, {
      onNow: this.handleNowClick,
      text: this.locale.now
    }, () => [a(d, {
      theme: r.peers.Button,
      themeOverrides: r.peerOverrides.Button,
      size: "tiny",
      onClick: this.handleNowClick
    }, {
      default: () => this.locale.now
    })]) : null, l != null && l.includes("confirm") ? h(this.datePickerSlots.confirm, {
      onConfirm: this.handleConfirmClick,
      disabled: this.isDateInvalid,
      text: this.locale.confirm
    }, () => [a(d, {
      theme: r.peers.Button,
      themeOverrides: r.peerOverrides.Button,
      size: "tiny",
      type: "primary",
      disabled: this.isDateInvalid,
      onClick: this.handleConfirmClick
    }, {
      default: () => this.locale.confirm
    })]) : null)) : null, a(g, {
      onFocus: this.handleFocusDetectorFocus
    }));
  }
});
export {
  T as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/date-picker/src/panel/month.js
// module id = 907
// module chunks = 41